// routes/paths.ts
//
// The app's route paths in one place. Pass these to `navigate()`,
// `<Navigate to>` and `<Link to>` instead of a '/…' literal; ESLint
// (ora/no-literal-route-path) rejects the literal. When you need a path that is
// not here, add it: a string for a fixed path, a function for one with
// parameters.
//
// Paths with their own module: course session steps (`courseSessionStepPath`
// in ./courseSessionPath.ts), topics pages (`buildTopicsPath` in
// src/utils/topicTreeV5Routing.ts), library articles (`buildLibraryArticlePath`
// in src/utils/libraryRouting.ts) and auth redirects (`buildAuthPath` in
// src/utils/authRedirect.ts).

export const paths = {
  home: '/',
  auth: '/auth',
  dashboard: '/dashboard',
  modules: '/modules',
  topics: '/topics',
  performance: '/performance',
  videos: '/videos',
  qbankStart: '/qbank-start',
  flashcards: '/flashcards',
  /** The flashcard decks of one exam. */
  examFlashcards: (examId: string) => `/flashcards/${examId}`,
  uploadDeck: '/upload-deck',
  library: '/library',
  selfAssessments: '/self-assessments',
  games: '/games',
  help: '/help',
  pricing: '/pricing',
  faculty: '/faculty',
  /** The account page with its menu open (phone layout). */
  accountMenu: '/account?open-menu=true',
} as const;
